import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentaBancarias";
import CatalogoProveedorPresupuesto from "../../catalogos/catalogoProveedorm";
import moment from "moment";

export const ImpBancos = (props) => {
  // --- DATA PARA RUTAS Y PARAMETROS ---
  let op = require("../../../src/modulos/datos");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  const post = JSON.parse(localStorage.getItem("post"));
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);

  // --- ESTADO PARA VISIBILIDAD DE PROVEEDOR ---
  const [modoProveedor, setModoProveedor] = useState('seleccionar');

  // --- ESTADO PARA SELECCIÓN DE BANCO ---
  const [modoBanco, setModoBanco] = useState('seleccionar');

  // --- ESTADO PARA RADIO BUTTONS ---
  const [opcionEgresos, setOpcionEgresos] = useState('todos');
  const [seleccionDeposito, setSeleccionDeposito] = useState('resumen');
  const [fechaDeposito, setFechaDeposito] = useState('todo');
  const [fechaUtilizar, setFechaUtilizar] = useState('deposito');
  const [estatusNotas, setEstatusNotas] = useState('todas');
  const [tipoNotas, setTipoNotas] = useState('debito-credito');

  // --- ESTADO PARA COMBO DINÁMICOS ---
  const [ubicaciones, setUbicaciones] = useState([]);
  const [meses, setMeses] = useState([]);
  const [anios, setAnios] = useState([]);

  // --- REFS ---
  // Banco
  const bancoCodigoRef = useRef();
  const bancoNombreRef = useRef();

  // Fechas
  const fechaDesdeRef = useRef();
  const fechaHastaRef = useRef();

  // Selects
  const ubicacionRef = useRef();
  const mesRef = useRef();
  const anioRef = useRef();

  // Proveedor
  const provCodigoRef = useRef();
  const provNombreRef = useRef();

  // Radio buttons para banco
  const radioBancoSelectRef = useRef();
  const radioBancoIndividualRef = useRef();

  // --- DATA PARA MAPS ---
  // Se cargarán dinámicamente en useEffect

  const titulo = {
    112: 'Movimientos según banco',
    113: 'Resumen de Gastos',
    114: 'Egresos Emitidos (Por tipo de Documento)',
    115: 'Transferencias Bancarias',
    116: 'Depósitos Bancarios',
    117: 'Notas de Débito y de Crédito',
    118: 'Relación de Egreso'
  };

  // --- USE EFFECT PARA CARGAR DATOS ---
  useEffect(() => {
    // Cargar ubicaciones dinámicamente (como en Java para reporte 27)
    if (props.reporte === 118) {
      const ubicacionesData = [
        { value: "", label: "TODOS" },
        { value: "44", label: "TESORERIA CHEQUE ASIGNADO" },
        { value: "45", label: "DESPACHO" },
        { value: "46", label: "TESORERIA POR PAGO" },
        { value: "48", label: "PAGADO" },
        { value: "49", label: "ADMINISTRACION POR FIRMA" }
      ];
      setUbicaciones(ubicacionesData);
    } else if (props.reporte === 27) { // Para compatibilidad si se usa el reporte 27
      const ubicacionesData = [
        { value: "", label: "TODOS" },
        { value: "44", label: "TESORERIA CHEQUE ASIGNADO" },
        { value: "45", label: "DESPACHO" },
        { value: "46", label: "TESORERIA POR PAGO" },
        { value: "48", label: "PAGADO" },
        { value: "49", label: "ADMINISTRACION POR FIRMA" }
      ];
      setUbicaciones(ubicacionesData);
    }

    // Cargar meses dinámicamente (como en llenarCombo() del Java)
    const mesesData = [
      { value: "1", label: "ENERO" },
      { value: "2", label: "FEBRERO" },
      { value: "3", label: "MARZO" },
      { value: "4", label: "ABRIL" },
      { value: "5", label: "MAYO" },
      { value: "6", label: "JUNIO" },
      { value: "7", label: "JULIO" },
      { value: "8", label: "AGOSTO" },
      { value: "9", label: "SEPTIEMBRE" },
      { value: "10", label: "OCTUBRE" },
      { value: "11", label: "NOVIEMBRE" },
      { value: "12", label: "DICIEMBRE" }
    ];
    setMeses(mesesData);

    // Cargar años dinámicamente (como en llenarCombo() del Java)
    const fechaActual = new Date();
    const anioActual = fechaActual.getFullYear();
    const aniosData = [];
    
    // Similar al Java: int aini = Integer.valueOf(CargarParametros.getAnioCurso()) - 7;
    const anioInicial = anioActual - 5;
    const anioFinal = anioActual;
    
    /* for (let i = anioInicial + 1; i <= anioFinal; i++) {
      aniosData.push({ value: i.toString(), label: i.toString() });
    } */
   for (let i = anioFinal; i >= anioInicial; i--) {
      aniosData.push({ value: i.toString(), label: i.toString() });
    }
    
    // Ordenar de más antiguo a más reciente
    setAnios(aniosData);
    
    // Si hay años, seleccionar el más reciente (como en Java: cmbAño.select(p - 1))
    if (aniosData.length > 0 && anioRef.current) {
      setTimeout(() => {
        anioRef.current.value = anioActual.toString();
      }, 100);
    }
    
    // Si hay meses, seleccionar el primero (como en Java: cmbMes.select(0))
    if (mesRef.current) {
      setTimeout(() => {
        mesRef.current.value = "1"; // Enero
      }, 100);
    }

  }, [props.reporte]);

  // --- FUNCIONES AUXILIARES ---
  const lpad = (str, pad, length) => {
    while (str.length < length) {
      str = pad + str;
    }
    return str;
  }

  const diasMes = (mes, anio) => {
    return new Date(anio, mes, 0).getDate();
  }

  // --- FUNCIONES DE CONTROL ---
  const cerrar = () => {
    props.cancelar();
  };

  const limpiar = () => {
    // Resetear Textos
    if (bancoCodigoRef.current) bancoCodigoRef.current.value = "";
    if (bancoNombreRef.current) bancoNombreRef.current.value = "";
    if (fechaDesdeRef.current) fechaDesdeRef.current.value = "";
    if (fechaHastaRef.current) fechaHastaRef.current.value = "";
    if (provCodigoRef.current) provCodigoRef.current.value = "";
    if (provNombreRef.current) provNombreRef.current.value = "";

    // Resetear Selects
    if (mesRef.current) mesRef.current.value = "1"; // Enero por defecto
    if (anioRef.current) {
      const fechaActual = new Date();
      anioRef.current.value = fechaActual.getFullYear().toString();
    }
    if (ubicacionRef.current) ubicacionRef.current.value = "";

    // Resetear Estados
    setModoProveedor('seleccionar');
    setModoBanco('seleccionar');
    setOpcionEgresos('todos');
    setSeleccionDeposito('resumen');
    setFechaDeposito('todo');
    setEstatusNotas('todas');
    setTipoNotas('debito-credito');

    props.cancelar();
  }

  // --- FUNCION IMPRIMIR ---
  const imprimir = () => {
    let idEfi = idefiscal;
    let tit = titulo[props.reporte] || 'Reporte';
    let org = post.nombreorg;

    // --- REPORTE 112: Movimientos según banco (tiporep 53) ---
    if (props.reporte === 112) {
      try {
        let mesVal = mesRef.current.value;
        let anioVal = anioRef.current.value;
        let bancoCod = bancoCodigoRef.current.value;

        if (!mesVal || !anioVal) {
          alert("Debe seleccionar Mes y Año");
          return;
        }
        if (!bancoCod || bancoCod.trim() === "") {
          alert("Debe seleccionar un Banco");
          return;
        }

        let nDias = diasMes(parseInt(mesVal), parseInt(anioVal));
        let val2 = "01" + "-" + lpad(mesVal, "0", 2) + "-" + anioVal;
        let val3 = String(nDias) + "-" + lpad(mesVal, "0", 2) + "-" + anioVal;

        let mesAnt = 0;
        let anioAnt = 0;
        if (mesVal === "01") {
          mesAnt = 12;
          anioAnt = parseInt(anioVal) - 1;
        } else {
          mesAnt = parseInt(mesVal) - 1;
          anioAnt = parseInt(anioVal);
        }

        let sql = "MOV_FECHAEDOCTA Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'" +
          " AND MOV_FECHA <= " + "'" + val3 + "'" +
          " AND mov.mov_idctabco = " + bancoCod.trim();

        let sql3 = "fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'" +
          " AND MOV.idcuentabancaria = " + bancoCod.trim();

        let sql4 = "MOV_FECHA Between" + "'" + val2 + "' And '" + val3 + "'";

        let fileName = "Tes_MovBanco";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&CONDICION=" + encodeURIComponent(sql) +
          "&CONDICION1=" + encodeURIComponent(sql3) +
          "&DESDE=" + encodeURIComponent("'" + val2 + "'") +
          "&MESANT=" + mesAnt +
          "&ANIOANT=" + anioAnt +
          "&IDCTA=" + encodeURIComponent(bancoCod.trim()) +
          "&HASTA=" + encodeURIComponent("'" + val3 + "'") +
          "&TIT_CRI1=" + encodeURIComponent(meses.find(m => m.value === mesVal)?.label + "/" + anioVal) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        alert("Mensaje de Error: " + error.message);
      }
    }

    // --- REPORTE 118: Relación de Egreso (tiporep 27) ---
    else if (props.reporte === 118) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          alert("Debe Introducir la Fecha de Inicio y Fin");
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let ubicacionVal = ubicacionRef.current.value;
        let sql1 = "true";

        if (ubicacionVal) {
          switch (ubicacionVal) {
            case "44": sql1 = "CHQ.ubicacion = 44"; break;
            case "45": sql1 = "CHQ.ubicacion = 45"; break;
            case "46": sql1 = "CHQ.ubicacion = 46"; break;
            case "48": sql1 = "CHQ.ubicacion = 48"; break;
            case "49": sql1 = "CHQ.ubicacion = 49"; break;
            default: sql1 = "true"; break;
          }
        }

        let sqlProv = "";
        if (modoProveedor === 'seleccionar' && provCodigoRef.current.value.trim() !== "") {
          sqlProv = " AND idproveedor = " + provCodigoRef.current.value.trim();
        }

        let sql = "FechaEmi Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        let fileName = "Tes_EgresoNumOrden";

        let condicionCompleta = sql.trim() + "AND " + sql1.trim() + ' ' + sqlProv.trim();

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2) +
          "&HASTA=" + encodeURIComponent("'" + val3 + "'") +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        alert("Mensaje de Error: " + error.message);
      }
    }

    // --- REPORTE 113: Relación de Gastos (Egresos) (tiporep 55) ---
    else if (props.reporte === 113) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          alert("Debe Introducir la Fecha de Inicio y Fin");
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let sql = " Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        let fileName = "RelacionEgreso";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&CONDICION=" + encodeURIComponent(sql.trim()) +
          "&TITFEC=" + encodeURIComponent(sql2.trim()) +
          "&HASTA=" + encodeURIComponent("'" + val3 + "'") +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        alert("Mensaje de Error: " + error.message);
      }
    }

    // --- REPORTE 114: Egresos Emitidos (tiporep 50) ---
    else if (props.reporte === 114) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;
        let bancoCod = radioBancoSelectRef.current.checked ? bancoCodigoRef.current.value : '';

        if (!fDesde || !fHasta) {
          alert("Debe Introducir la Fecha de Inicio y Fin");
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let sql = "";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";
        let fileName = "";
        let tit_rgo2 = "";

        let bancoCond = "";
        if (radioBancoSelectRef.current.checked) {
          bancoCond = " AND BCO.idcuentabancaria = " + bancoCod.trim();
        }

        if (opcionEgresos === 'cheque') {
          sql = "FechaEmi Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'" + bancoCond + " And CHQ.tipo = 1 And CHQ.reversado = 0";
          tit_rgo2 = "Cheques Emitidos";
          fileName = "Tes_ChequeNumOrden";

        } else if (opcionEgresos === 'documento') {
          sql = "FechaEmi Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'" + bancoCond + " And CHQ.tipo = 3 And CHQ.reversado = 0";
          tit_rgo2 = "Cheques Anulados";
          fileName = "Tes_ChequeDocNumOrden";

        } else {
          sql = "FechaEmi Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'" + bancoCond + " And CHQ.reversado = 0";
          tit_rgo2 = "Cheques Anulados";
          fileName = "Tes_ChequeNumOrden";

        }

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&CONDICION=" + encodeURIComponent(sql) +
          "&TIT_RGO1=" + encodeURIComponent(sql2) +
          "&TIT_RGO2=" + encodeURIComponent(tit_rgo2) +
          "&HASTA=" + encodeURIComponent("'" + val3 + "'") +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        alert("Mensaje de Error: " + error.message);
      }
    }

    // --- REPORTE 115: Resumen de Transferencias Bancarias (tiporep 6) ---
    else if (props.reporte === 115) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          alert("Debe Introducir la Fecha de Inicio y Fin");
          return;
        }

        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let sql = "Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        let fileName = "Tes_BcoTransf";

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&CONDICION=" + encodeURIComponent(sql) +
          "&TIT_RGO1=" + encodeURIComponent(sql2) +
          "&HASTA=" + encodeURIComponent("'" + val3 + "'") +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        alert("Mensaje de Error: " + error.message);
      }
    }

    // --- REPORTE 116: Depósitos Bancarios (tiporep == 13 de FrmImpVarios) ---
    else if (props.reporte === 116) {
      try {
        let val2, val3;
        let sql, sql2, fileName;

        // Lógica de Fechas (radioAnterior vs radioActual en Java)
        if (fechaDeposito === 'todo') {
          sql = "TRUE";
          sql2 = "Depósitos Bancarios";
        } else {
          // Por Fecha
          if (!fechaDesdeRef.current.value || !fechaHastaRef.current.value) {
            alert("Debe Introducir la Fecha de Inicio y Fin");
            return;
          }
          let partsDesde = fechaDesdeRef.current.value.split('-');
          val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
          let partsHasta = fechaHastaRef.current.value.split('-');
          val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

          sql = "DEP.FechaDeposito Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
          sql2 = "ENTRE EL DIA" + " " + "'" + val2 + "'" + " " + "Y EL DIA" + " " + "'" + val3 + "'";
        }

        // Lógica de Selección (radioTodos en Java vs seleccionDeposito en React)
        // Java usa 'radioTodos' para elegir entre Resumido y Detallado
        if (seleccionDeposito === 'resumen') {
          fileName = "Tes_BcoDepositosResu";
        } else {
          fileName = "Tes_BcoDepositos";
        }

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&CONDICION=" + encodeURIComponent(sql) +
          "&TIPODEP=" + encodeURIComponent(" DEP.ESP = 0") + // Parámetro fijo del Java
          "&TIT_RGO1=" + encodeURIComponent(sql2) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        alert("Mensaje de Error: " + error.message);
      }
    }

    else if (props.reporte === 117) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          alert("Debe Introducir la Fecha de Inicio y Fin");
          return;
        }

        // Convertir fechas de YYYY-MM-DD (Input Date) a DD-MM-YYYY (Formato SQL del Java)
        let partsDesde = fDesde.split('-');
        let val2 = partsDesde[2] + '-' + partsDesde[1] + '-' + partsDesde[0];
        let partsHasta = fHasta.split('-');
        let val3 = partsHasta[2] + '-' + partsHasta[1] + '-' + partsHasta[0];

        let sql = "";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";
        let sql1 = "";
        let sql3 = "";

        let bancoCod = bancoCodigoRef.current ? bancoCodigoRef.current.value.trim() : "";

        // Lógica de Banco
        // En Java: if (radioIndividual.getSelection() == true) añade ID Banco.
        // En React: modoBanco === 'seleccionar' muestra los inputs de banco.
        if (modoBanco === 'seleccionar' && bancoCod !== "") {
          sql = "Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'" + " AND BCO.idcuentabancaria = " + bancoCod;
        } else {
          sql = "Fecha Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        }

        // Lógica de Tipo de Notas (Débito/Crédito)
        if (tipoNotas === 'debito-credito') {
          sql1 = " AND true";
        } else if (tipoNotas === 'debito') {
          sql1 = " AND DOC.tipo = 16";
        } else if (tipoNotas === 'credito') {
          sql1 = " AND DOC.tipo = 17";
        }

        // Lógica de Estatus de Reverso
        if (estatusNotas === 'todas') {
          sql3 = " AND true";
        } else if (estatusNotas === 'sinReversar') {
          sql3 = " AND DOC.reversado = 0";
        } else if (estatusNotas === 'reversadas') {
          sql3 = " AND DOC.reversado = 1";
        }

        let fileName = "Tes_BcoDebCre";
        let condicionCompleta = sql.trim() + sql1 + sql3;

        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&EFISCAL=" + idEfi +
          "&efiscal=" + idEfi + // Se envían ambos para asegurar compatibilidad como en otros reportes
          "&CONDICION=" + encodeURIComponent(condicionCompleta) +
          "&TIT_RGO1=" + encodeURIComponent(sql2) +
          "&HASTA=" + encodeURIComponent("'" + val3 + "'") +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        alert("Mensaje de Error: " + error.message);
      }
    }

    // --- OTROS REPORTES ---
    else {
      alert("Este reporte aún no está configurado en la función imprimir.");
    }
  };

  const onHideCuentaBancaria = (values) => {
    setMostrar(false)
    console.log(values)
    bancoCodigoRef.current.value = values.idcuentabancaria;
    bancoNombreRef.current.value = values.nombre.trim() + ' / ' + values.cuentabancaria;
  }

  const onHideAceptaCatProv = (responsable, razonsocial, idproveedor, rif) => {
    setMostrar2(false)
    console.log(responsable, razonsocial, idproveedor, rif)
    provCodigoRef.current.value = idproveedor
    provNombreRef.current.value = razonsocial + ' ' + rif
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          {titulo[props.reporte]} 
        </h3>
        <button className="btn btn-sm bg-light" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-md-12 row mx-auto px-0">

          {/* Radio buttons para selección de banco */}
          {props.reporte === 114 || props.reporte === 116 || props.reporte === 117 ? (
            <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioBancoSelectRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioBanco"
                    id="radioBancoSelect"
                    checked={modoBanco === 'seleccionar'}
                    onChange={() => setModoBanco('seleccionar')}
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioBancoSelect">
                    Seleccionar Banco
                  </label>
                </div>
              </div>

              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioBancoIndividualRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioBanco"
                    id="radioBancoIndividual"
                    checked={modoBanco === 'individual'}
                    onChange={() => setModoBanco('individual')}
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioBancoIndividual">
                    Individual
                  </label>
                </div>
              </div>
            </div>
          ) : ''}

          {/* Inputs de banco */}
          {(props.reporte === 112 || props.reporte === 114 || props.reporte === 116 || props.reporte === 117) && modoBanco === 'seleccionar' ? (
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none text-uppercase w-auto m-0">Banco</legend>
              <div className="input-group input-group-sm col-md-12 mx-auto mb-1">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Código:</span>
                <input
                  ref={bancoCodigoRef}
                  disabled
                  type="text"
                  className="form-control text-uppercase col-md-1"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <button type="button" onClick={() => { setMostrar(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>

                <input
                  ref={bancoNombreRef}
                  disabled
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </fieldset>
          ) : ''}

          {/* Mes y Año para reporte 112 */}
          {props.reporte === 112 ? (
            <div className="col-md-12 row mx-auto px-0">
              <div className="input-group input-group-sm col-md-6 mx-auto mb-1 px-0 mt-2">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Mes:</span>
                <select
                  ref={mesRef}
                  className="form-select"
                  aria-label="Default select example"
                >
                  {/* <option value="">Seleccione una opción</option> */}
                  {meses.map((mes) => (
                    <option key={mes.value} value={mes.value}>
                      {mes.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group input-group-sm col-md-6 mx-auto mb-1 px-0 mt-2">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Año:</span>
                <select
                  ref={anioRef}
                  className="form-select"
                  aria-label="Default select example"
                >
                  {/* <option value="">Seleccione una opción</option> */}
                  {anios.map((anio) => (
                    <option key={anio.value} value={anio.value}>
                      {anio.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ) : ''}

          {/* Fechas para varios reportes */}
          {props.reporte === 118 || props.reporte === 113 || props.reporte === 114 || props.reporte === 115 || props.reporte === 117 ? (
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded row">
              <legend className="float-none text-uppercase w-auto m-0">Buscar Por</legend>
              <div className="col-md-12 mx-auto row my-auto py-0">
                <div className="input-group input-group-sm col-md-5 mb-0">
                  <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Desde la Fecha:</span>
                  <input
                    ref={fechaDesdeRef}
                    type="date"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
                  />
                </div>
                <div className="input-group input-group-sm col-md-5 mb-0">
                  <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Hasta la Fecha:</span>
                  <input
                    ref={fechaHastaRef}
                    type="date"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
                  />
                </div>
              </div>
            </fieldset>
          ) : ''}

          {/* Ubicación para reporte 118 */}
          {props.reporte === 118 ? (
            <div className="input-group input-group-sm col-md-12 mx-auto mb-1 px-0 mt-2">
              <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Ubicación:</span>
              <select
                ref={ubicacionRef}
                className="form-select"
                aria-label="Default select example"
              >
                {/* <option value="">Seleccione una opción</option> */}
                {ubicaciones.map((op) => (
                  <option key={op.value} value={op.value}>
                    {op.label}
                  </option>
                ))}
              </select>
            </div>
          ) : ''}

          {/* Proveedor para reporte 118 */}
          {props.reporte === 118 ? (
            <>
              <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioProveedor"
                      id="radioProvSelect"
                      checked={modoProveedor === 'seleccionar'}
                      onChange={() => setModoProveedor('seleccionar')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioProvSelect">
                      Seleccionar Proveedor
                    </label>
                  </div>
                </div>

                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioProveedor"
                      id="radioProvTodos"
                      checked={modoProveedor === 'todos'}
                      onChange={() => setModoProveedor('todos')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioProvTodos">
                      Todos
                    </label>
                  </div>
                </div>
              </div>

              {modoProveedor === 'seleccionar' ? (
                <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                  <legend className="float-none text-uppercase w-auto m-0">Proveedor</legend>
                  <div className="input-group input-group-sm col-md-12 mx-auto mb-1">
                    <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Código:</span>
                    <input
                      ref={provCodigoRef}
                      type="text"
                      disabled
                      className="form-control text-uppercase col-md-1"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button onClick={()=>setMostrar2(true)} type="button" className="btn btn-success"><i className="fas fa-search"></i></button>
                    <input
                      ref={provNombreRef}
                      type="text"
                      disabled
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </fieldset>
              ) : ''}
            </>
          ) : ''}

          {/* Opciones de egresos para reporte 114 */}
          {props.reporte === 114 ? (
            <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioEgresos"
                    id="radioEgresosTodos"
                    checked={opcionEgresos === 'todos'}
                    onChange={() => setOpcionEgresos('todos')}
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioEgresosTodos">
                    Todos los Egresos
                  </label>
                </div>
              </div>

              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioEgresos"
                    id="radioEgresosCheque"
                    checked={opcionEgresos === 'cheque'}
                    onChange={() => setOpcionEgresos('cheque')}
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioEgresosCheque">
                    Egresos Tipo Cheque
                  </label>
                </div>
              </div>

              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioEgresos"
                    id="radioEgresosDocumento"
                    checked={opcionEgresos === 'documento'}
                    onChange={() => setOpcionEgresos('documento')}
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioEgresosDocumento">
                    Egresos Tipo Documento
                  </label>
                </div>
              </div>
            </div>
          ) : ''}

          {/* Selección de tipo de depósito para reporte 116 */}
          {props.reporte === 116 ? (
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none text-uppercase w-auto m-0">Selección</legend>
              <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioDeposito"
                      id="radioDepositoResumen"
                      checked={seleccionDeposito === 'resumen'}
                      onChange={() => setSeleccionDeposito('resumen')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioDepositoResumen">
                      Resumen
                    </label>
                  </div>
                </div>

                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioDeposito"
                      id="radioDepositoDetallado"
                      checked={seleccionDeposito === 'detallado'}
                      onChange={() => setSeleccionDeposito('detallado')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioDepositoDetallado">
                      Detallado
                    </label>
                  </div>
                </div>

                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioDeposito"
                      id="radioDepositoGeneral"
                      checked={seleccionDeposito === 'general'}
                      onChange={() => setSeleccionDeposito('general')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioDepositoGeneral">
                      General
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>
          ) : ''}

          {/* Fecha de depósitos para reporte 116 */}
          {props.reporte === 116 ? (
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none text-uppercase w-auto m-0">Fecha Depositos</legend>
              <div className="col-md-12 mx-auto row px-0">
                <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
                  <div className="col-md-4 row mx-auto mb-2">
                    <div className="form-check my-auto">
                      <input
                        className="form-check-input text-uppercase my-auto"
                        type="radio"
                        name="radioFechaDeposito"
                        id="radioFechaTodo"
                        checked={fechaDeposito === 'todo'}
                        onChange={() => setFechaDeposito('todo')}
                      />
                      <label className="form-check-label text-uppercase my-auto" htmlFor="radioFechaTodo">
                        Todo
                      </label>
                    </div>
                  </div>

                  <div className="col-md-4 row mx-auto mb-2">
                    <div className="form-check my-auto">
                      <input
                        className="form-check-input text-uppercase my-auto"
                        type="radio"
                        name="radioFechaDeposito"
                        id="radioFechaPorFecha"
                        checked={fechaDeposito === 'porFecha'}
                        onChange={() => setFechaDeposito('porFecha')}
                      />
                      <label className="form-check-label text-uppercase my-auto" htmlFor="radioFechaPorFecha">
                        Por Fecha
                      </label>
                    </div>
                  </div>
                </div>

                {fechaDeposito === 'porFecha' && (
                  <>
                    <div className="col-md-12 mx-auto row my-auto mt-2 py-2">
                      <div className="input-group input-group-sm col-md-5 mb-0">
                        <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Desde la Fecha:</span>
                        <input
                          ref={fechaDesdeRef}
                          type="date"
                          className="form-control text-uppercase"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>
                      <div className="input-group input-group-sm col-md-5 mb-0">
                        <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Hasta la Fecha:</span>
                        <input
                          ref={fechaHastaRef}
                          type="date"
                          className="form-control text-uppercase"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>
                    </div>

                    <fieldset className="col-12 m-0 p-2 d-flex mx-auto border-azul rounded">
                      <legend className="float-none text-uppercase w-auto m-0">Utilizar Fecha de</legend>
                      <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
                        <div className="col-md-4 row mx-auto mb-2">
                          <div className="form-check my-auto">
                            <input
                              className="form-check-input text-uppercase my-auto"
                              type="radio"
                              name="radioFechaUtilizar"
                              id="radioFechaDeposito"
                              checked={fechaUtilizar === 'deposito'}
                              onChange={() => setFechaUtilizar('deposito')}
                            />
                            <label className="form-check-label text-uppercase my-auto" htmlFor="radioFechaDeposito">
                              Depósito
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 row mx-auto mb-2">
                          <div className="form-check my-auto">
                            <input
                              className="form-check-input text-uppercase my-auto"
                              type="radio"
                              name="radioFechaUtilizar"
                              id="radioFechaIngreso"
                              checked={fechaUtilizar === 'ingreso'}
                              onChange={() => setFechaUtilizar('ingreso')}
                            />
                            <label className="form-check-label text-uppercase my-auto" htmlFor="radioFechaIngreso">
                              Ingreso
                            </label>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </>
                )}
              </div>
            </fieldset>
          ) : ''}

          {/* Estatus de notas para reporte 117 */}
          {props.reporte === 117 ? (
            <fieldset className="col-12 m-0 p-2 d-flex mx-auto border-azul rounded">
              <legend className="float-none text-uppercase w-auto m-0">Estatus de las Notas de Débito y Crédito</legend>
              <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioEstatusNotas"
                      id="radioEstatusTodas"
                      checked={estatusNotas === 'todas'}
                      onChange={() => setEstatusNotas('todas')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioEstatusTodas">
                      Todas
                    </label>
                  </div>
                </div>

                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioEstatusNotas"
                      id="radioEstatusSinReversar"
                      checked={estatusNotas === 'sinReversar'}
                      onChange={() => setEstatusNotas('sinReversar')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioEstatusSinReversar">
                      Sin Reversar
                    </label>
                  </div>
                </div>

                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioEstatusNotas"
                      id="radioEstatusReversadas"
                      checked={estatusNotas === 'reversadas'}
                      onChange={() => setEstatusNotas('reversadas')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioEstatusReversadas">
                      Reversadas
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>
          ) : ''}

          {/* Tipo de notas para reporte 117 */}
          {props.reporte === 117 ? (
            <fieldset className="col-12 m-0 p-2 d-flex mx-auto border-azul rounded">
              <legend className="float-none text-uppercase w-auto m-0">Notas de Débito y Crédito</legend>
              <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoNotas"
                      id="radioTipoDebitoCredito"
                      checked={tipoNotas === 'debito-credito'}
                      onChange={() => setTipoNotas('debito-credito')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoDebitoCredito">
                      Débito y Crédito
                    </label>
                  </div>
                </div>

                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoNotas"
                      id="radioTipoDebito"
                      checked={tipoNotas === 'debito'}
                      onChange={() => setTipoNotas('debito')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoDebito">
                      Débito
                    </label>
                  </div>
                </div>

                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoNotas"
                      id="radioTipoCredito"
                      checked={tipoNotas === 'credito'}
                      onChange={() => setTipoNotas('credito')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoCredito">
                      Crédito
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>
          ) : ''}

          <CatalogoCuentaBancaria
            show={mostrar}
            onHideCancelar={() => setMostrar(false)}
            onHideAceptaCatalogo={onHideCuentaBancaria}

          />

          <CatalogoProveedorPresupuesto
            show={mostrar2}
            onHideCancelar={() => setMostrar2(false)}
            onHideAceptaProveedor={onHideAceptaCatProv}

          />


        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-sm btn-primary text-uppercase" onClick={imprimir}>
          <i className="fas fa-print me-2"></i> Imprimir
        </button>
        <button className="btn btn-sm btn-secondary text-uppercase" onClick={limpiar}>
          <i className="fas fa-times me-2"></i> Cancelar
        </button>
      </Modal.Footer>

    </Modal>
  );
};